module.exports = __webpack_public_path__ + "img/back-icon.d770dde9.svg";